

























































































































































import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import PageDefaultLayout from '@/components/globals/PageDefaultLayout.vue'
import FacilityListWithPrograms from '@/components/facility/FacilityListWithPrograms.vue'
import Loading from '@/components/globals/basics/Loading/Loading.vue'
import NoContentBorderedBox from '@/components/globals/basics/NoContentBorderedBox.vue'
import ToggleList, {
  ToggleListItem,
} from '@/components/globals/basics/ToggleList.vue'
// import FloatingButton from '@/components/globals/FloatingButton.vue'
import ProgramPagination from '@/components/program/ProgramPagination.vue'
import MapView from '@/components/map/MapView.vue'
import SearchFacilityDetailModal from '@/components/modal/SearchFacilityModal/SearchFacilityDetailModal.vue'
import SearchFacilityDetailForm from '@/components/modal/SearchFacilityModal/basics/SearchFacilityDetailForm.vue'
import {
  listFacilities,
  Facility,
  AreaId,
  FacilityId,
  SearchParams,
  queryToSearchHistory,
  setSearchHistory,
  // searchHistoryToReadableString,
  conditionsToPath,
  AreasByPref,
  Area,
  facilitiesSearchCount,
  useFacilitiesMetadataStore,
} from '@/core/Facilities'
import {
  listFavoriteFacilities,
  markFacilityAsFavorite,
  unmarkFacilityAsFavorite,
} from '@/core/Favorites'
import snackbar from '@/tools/snackbar'
import showErrorDialog from '@/tools/error-dialog'
import { Activity } from '@/core/Activities'
import { PagerMeta } from '@/externals/gyym'
import {
  isVerifiedUser,
  verifyAuthEmail,
  castVerifyEmailParams,
  hasVerifyEmailQuery,
} from '@/core/Auth'

const sortItems: ToggleListItem[] = [
  {
    label: '価格順',
    value: {
      sortBy: 'minimumPoint',
      order: 'asc',
    },
  },
  {
    label: '評価順',
    value: {
      sortBy: 'reviewScore',
      order: 'desc',
    },
  },
  {
    label: '新着順',
    value: {
      sortBy: 'createdAt',
      order: 'desc',
    },
  },
  {
    label: 'レビュー数順',
    value: {
      sortBy: 'reviewCount',
      order: 'desc',
    },
  },
]

const facilitiesMetadataStore = useFacilitiesMetadataStore()

export default Vue.extend({
  name: 'FacilitySearchView',
  components: {
    PageDefaultLayout,
    FacilityListWithPrograms,
    ToggleList,
    Loading,
    // FloatingButton,
    SearchFacilityDetailForm,
    ProgramPagination,
    SearchFacilityDetailModal,
    MapView,
    NoContentBorderedBox,
  },
  props: {
    title: {
      type: String,
      default: '施設検索',
    },
    initialSearchParams: {
      type: Object as () => SearchParams,
      default: () => ({}),
    },
    prevPage: {
      type: Object as () => { name: string; path: string } | null,
      default: null,
    },
    // 強制的に結果を0にする
    forceEmptyResult: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSearching: false,
      isFetchingFavoritedFacilities: false,
      isLoadingResultCount: false,
      resultCount: 0,
      isRequestingFavorite: false,
      sortItems,
      currentSortValue: this.$route.query.sortBy
        ? {
            ...(
              sortItems.find(
                (item) => item.value.sortBy === this.$route.query.sortBy
              ) ?? sortItems[0]
            ).value,
          }
        : { ...sortItems[0].value },
      selectedAreaIds: [] as AreaId[],
      facilities: [] as Facility[],
      facilitiesMeta: {} as PagerMeta,
      favoritedFacilityIds: [] as FacilityId[],
      isMapView: Boolean(
        this.$route.query.view && this.$route.query.view === 'map'
      ),
    }
  },
  computed: {
    currentPage(): number | null {
      return this.$route.query.page
        ? Number(this.$route.query.page as string)
        : 1
    },
    isMasterFetching(): boolean {
      return facilitiesMetadataStore.isFetching()
    },
    isMasterFetched(): boolean {
      return facilitiesMetadataStore.isFetched()
    },
    activities(): Activity[] {
      return facilitiesMetadataStore.getActivities()
    },
    areasByPref(): AreasByPref[] {
      return facilitiesMetadataStore.getAreasByPref()
    },
    areas(): Area[] {
      return facilitiesMetadataStore.getAreas()
    },
    isLoggedIn(): boolean {
      return this.$store.getters['auth/isLogin']
    },
    isEmailVerified(): boolean {
      return this.$store.getters['auth/emailVerified']
    },
    facilitySearchValues(): SearchParams {
      return {
        ...queryToSearchHistory(this.$route.query),
        ...this.initialSearchParams,
      }
    },
    // searchString(): string {
    //   return searchHistoryToReadableString(
    //     this.facilitySearchValues,
    //     this.areas,
    //     this.activities
    //   )
    // },
  },
  watch: {
    currentPage() {
      this.search({
        ...this.facilitySearchValues,
        ...this.currentSortValue,
        page: this.currentPage,
      })
    },
  },
  async created() {
    await Promise.all([
      this.fetchData(),
      // Skip search on map view
      !this.isMapView ? this.search() : null,
      hasVerifyEmailQuery(this.$route.query)
        ? this.verifyEmail()
        : Promise.resolve(),
      this.isEmailVerified
        ? this.fetchFavoritedFacilities()
        : // ログインしていなければお気に入り情報は取得しない
          Promise.resolve(),
    ])
  },
  methods: {
    toggleMapView() {
      this.isMapView = !this.isMapView
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          view: this.isMapView ? 'map' : undefined,
        },
      })

      // Execute search on list view
      if (!this.isMapView) {
        this.search()
      }
    },
    async fetchCount(params?: SearchParams) {
      this.isLoadingResultCount = true
      const { count } = await facilitiesSearchCount(
        params || this.facilitySearchValues
      )
      this.resultCount = count
      this.isLoadingResultCount = false
    },
    async fetchFavoritedFacilities() {
      this.isFetchingFavoritedFacilities = true

      try {
        const favoriteFacilities = await listFavoriteFacilities()
        this.favoritedFacilityIds = favoriteFacilities.map(({ id }) => id)
      } catch (e) {
        // メール認証されていない場合にエラーとなるので一旦握りつぶす
      }

      this.isFetchingFavoritedFacilities = false
    },
    async fetchData() {
      await facilitiesMetadataStore.fetch()
    },
    async verifyEmail(): Promise<void> {
      if (!this.$store.getters['auth/isLogin']) {
        this.$router.push({ path: '/login', query: this.$route.query })
        return
      }

      if (!isVerifiedUser()) {
        try {
          await verifyAuthEmail(castVerifyEmailParams(this.$route.query as any))
        } catch (error) {
          Sentry.captureException(error)
          if (error.status === 429) {
            showErrorDialog({
              msg: '一時的なエラーが発生しました。ページをリロードしてください',
            })
          } else {
            showErrorDialog({ msg: 'メール認証を再度行ってください' })
          }
          return
        }
      }

      if (!this.$store.getters['auth/user'].name) {
        this.$modal.push('ProfileModal')

        // 立て続けに$modal.pushすると↑のProfileModalのイベントが発火されなくなるのでタイマーで少し遅延させる
        setTimeout(() => {
          this.$modal.push('CompleteRegisterModal', true)
        }, 50)
      }
    },
    async search(params?: SearchParams) {
      // 強制的に0件表示
      if (this.forceEmptyResult) {
        this.facilities = []
        this.facilitiesMeta = {} as PagerMeta
        return
      }

      try {
        this.isSearching = true

        const [{ data, meta }] = await Promise.all([
          listFacilities({
            ...(params || this.facilitySearchValues),
            ...this.currentSortValue,
            page: this.currentPage,
          }),
          this.fetchCount(params),
        ])
        this.facilities = data
        this.facilitiesMeta = meta
        this.isSearching = false
      } catch (e) {
        Sentry.captureException(e)
      }
    },
    handleSortChange(value: ToggleListItem['value']) {
      this.currentSortValue = value

      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          sortBy:
            value.sortBy === sortItems[0].value.sortBy
              ? undefined
              : value.sortBy,
        },
      })

      this.search()
    },
    onSearch(params: SearchParams) {
      // 市区町村コードはUIから変更できないため、再検索時にクリアする
      params.cityCode = null

      // 検索履歴を保持
      setSearchHistory(params)

      this.$router
        .push(
          conditionsToPath(
            params,
            this.areasByPref,
            this.currentSortValue.sortBy === sortItems[0].value.sortBy
              ? undefined
              : this.currentSortValue,
            this.isMapView
          )
        )
        .catch(() => {})

      // Skip search when map view
      if (this.isMapView) return

      this.search(params)
    },
    onSearchFromModal(params: SearchParams) {
      this.$modal.pop()
      this.onSearch(params)
    },
    async handleFavorited(facilityId: FacilityId, favorited: boolean) {
      // リクエスト中の場合は何もしない
      if (this.isRequestingFavorite) return

      // 未ログイン時はログイン画面に誘導するsnackbarを表示する
      if (!this.isLoggedIn) {
        snackbar({
          text: 'お気に入り登録にはログインが必要です',
          link: { to: '/login', text: 'ログインする' },
        })
        return
      }

      this.isRequestingFavorite = true

      try {
        // UIに先に反映する
        this.favoritedFacilityIds = favorited
          ? [...this.favoritedFacilityIds, facilityId]
          : this.favoritedFacilityIds.filter((id) => id !== facilityId)

        if (favorited) {
          await markFacilityAsFavorite(facilityId)
        } else {
          await unmarkFacilityAsFavorite(facilityId)
        }

        snackbar({
          text: `お気に入り${favorited ? '登録' : '解除'}しました。`,
        })
      } catch (e) {
        // リクエストに失敗したため、UIを元の状態に戻す
        this.favoritedFacilityIds = favorited
          ? this.favoritedFacilityIds.filter((id) => id !== facilityId)
          : [...this.favoritedFacilityIds, facilityId]

        snackbar({
          text: `お気に入り${favorited ? '登録' : '解除'}できませんでした。${
            e.errors.verified ? e.errors.verified : ''
          }`,
        })
      } finally {
        this.isRequestingFavorite = false
      }
    },
  },
})
